import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { IonApp, IonMenu, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Page from './pages/Page';
import Menu from './pages/Menu';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactUs from './pages/ContactUs';
import Faq from './pages/Faq';
import AboutUs from './pages/AboutUs';
import Disclaimer from './pages/Disclaimer';
import AllClasses from './pages/AllClasses';
import AllOlympiad from './pages/AllOlympiad';
import IMO from './components/Olympiad/IMO';
import NSO from './components/Olympiad/NSO';
import IEO from './components/Olympiad/IEO';

setupIonicReact();

const App: React.FC = () => {
    return (
        <IonApp>
            <IonReactRouter>
                <MainApp />
            </IonReactRouter>
        </IonApp>
    );
};

const MainApp: React.FC = () => {
    const location = useLocation();
    const [showMenuButton, setShowMenuButton] = useState(false);

    useEffect(() => {
        // This happens instantly
        const menuButton = (location.pathname !== '/' && location.pathname !== '/privacy-policy' && location.pathname !== '/contact-us' && location.pathname !== '/faq' && location.pathname !== '/about-us' && location.pathname !== '/disclaimer' && location.pathname !== '/all-classes' && location.pathname !== '/all-olympiads' && location.pathname !== '/imo' && location.pathname !== '/nso' && location.pathname !== '/ieo' );
        setShowMenuButton(menuButton);

        // Delay only scroll logic
        const timeout = setTimeout(() => {
            const element = document.getElementsByClassName("selected")[0];
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, 500); // Delay only if really needed

        return () => clearTimeout(timeout);
    }, [location.pathname]);




    return (
        <IonSplitPane contentId="main">

            <IonMenu contentId="main" type="overlay" className="my-menu" disabled={!showMenuButton}>
                <Menu />
            </IonMenu>
            <IonRouterOutlet id="main">
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    <Route exact path="/privacy-policy">
                        <PrivacyPolicy />
                    </Route>
                    <Route exact path="/contact-us">
                        <ContactUs />
                    </Route>
                    <Route exact path="/faq">
                        <Faq />
                    </Route>
                    <Route exact path="/about-us">
                        <AboutUs />
                    </Route>
                    <Route exact path="/disclaimer">
                        <Disclaimer />
                    </Route>
                    <Route exact path="/all-classes">
                        <AllClasses />
                    </Route>
                    <Route exact path="/all-olympiads">
                        <AllOlympiad />
                    </Route>
                    <Route exact path="/imo">
                        <IMO />
                    </Route>
                    <Route exact path="/nso">
                        <NSO />
                    </Route>
                    <Route exact path="/ieo">
                        <IEO />
                    </Route>
                    <Route path="/*">
                        <Page pagetitle="Choose Class" />
                    </Route>
                </Switch>
            </IonRouterOutlet>

        </IonSplitPane>
    )
};

export default App;
